<script setup lang="ts">
const route = useRoute();

const breadcrumbs = computed(() => {
  const crumbs = [];

  crumbs.push({
    label: 'Home',
    to: '/',
  });

  const segments = route.path.split('/').filter(Boolean);

  segments.forEach((segment, index) => {
    if (segment === 'user') return;

    let label = segment.charAt(0).toUpperCase() + segment.slice(1);
    const to = '/' + segments.slice(0, index + 1).join('/');

    if (segment === 'profile') {
      label = 'Perfil';
    }

    crumbs.push({
      label,
      to,
    });
  });

  return crumbs;
});
</script>

<template>
  <nav
    aria-label="Breadcrumb"
    class="breadcrumbs"
  >
    <ol class="flex items-center space-x-2 text-sm text-white">
      <li
        v-for="(crumb, index) in breadcrumbs"
        :key="index"
        class="flex items-center"
      >
        <NuxtLink
          v-if="index < breadcrumbs.length - 1"
          class="hover:text-white/40"
          :to="crumb.to"
        >
          {{ crumb.label }}
        </NuxtLink>
        <span
          v-else
          class="text-white/90 font-medium"
        >
          {{ crumb.label }}
        </span>
        <svg
          v-if="index < breadcrumbs.length - 1"
          class="w-4 h-4 mx-2 text-white/40"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            clip-rule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            fill-rule="evenodd"
          />
        </svg>
      </li>
    </ol>
  </nav>
</template>

<style scoped>
.breadcrumbs {
  margin-bottom: 1rem;
}
</style>
